import clsx from 'clsx';
import { type ToolbarType, useLayout } from '../../core';
import { PageTitleWrapper } from './page-title';
import { Toolbar } from './Toolbar';

const ToolbarWrapper = () => {
  const { config, classes, attributes, cssVariables } = useLayout();

  const isPageTitleVisible = showPageTitle(
    config.app?.toolbar?.layout,
    config.app?.pageTitle?.display,
    config.app?.toolbar?.display,
  );

  return (
    <div className={clsx('app-toolbar')} id="kt_app_toolbar">
      <div
        className={clsx(
          'app-container',
          classes.toolbarContainer.join(' '),
          config.app?.toolbar?.containerClass,
          config.app?.toolbar?.minimize?.enabled ? 'app-toolbar-minimize' : '',
          {
            'container-fluid': config.app?.toolbar?.container === 'fluid',
            'container-xxl': config.app?.toolbar?.container === 'fixed',
          },
        )}
        id="kt_app_toolbar_container"
      >
        {!!isPageTitleVisible && <PageTitleWrapper />}
        {!!config.app?.toolbar?.display && <Toolbar />}
      </div>
    </div>
  );
};

const showPageTitle = (
  appToolbarLayout?: ToolbarType,
  appPageTitleDisplay?: boolean,
  appToolbarDisplay?: boolean,
): boolean => {
  const viewsWithPageTitles = ['classic', 'reports', 'saas', 'accounting'];
  if (!appToolbarLayout || !appPageTitleDisplay || !appToolbarDisplay) {
    return false;
  }

  return appPageTitleDisplay && viewsWithPageTitles.some((t) => t === appToolbarLayout);
};

export { ToolbarWrapper };
